// extracted by mini-css-extract-plugin
export default {"section":"iaa7d","wrapperGallery":"oBmRP ZdH1P uFyfG","gallery":"D6wdN","footerText":"qQ4TR ZdH1P","footerPhoneLink":"h5mjd","navArrows":"_MqOW"};